import { useQuery } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';

interface TreatmentQueryInput{
    projectId:string
    featureId:string
}

export interface Treatment {
  id: string;
  name: string;
  default: boolean;
  description: string | null;
  rolloutPercentage: number;
  configuration: Record<string, string>;
  featureId: string;
  realmId: string;
  userId: string;
}

const getAllTreatments = async (featureId:string) => {
  try {
    const url = paths.getAllTreatments();
    const response = await axiosInstance.post(url, {input: {query:`featureId==${featureId}`}});
    const treatments = response?.data?.data?.treatments?.result;

    return Array.isArray(treatments) ? treatments as Treatment[] : [];
  } catch (error) {
    return Promise.reject(error);
  }
  
};



export const useGetAllTreatments = (featureId:string,options?:any) => {
    return useQuery(['get-all-treatments', featureId], () => getAllTreatments(featureId), {
        refetchInterval: false,
        refetchOnWindowFocus: false,
    ...options
    });
  };